<template>
  <div class="page-container">
    <div class="dc-grid">
      <div class="dc-card">
        <div class="dc-title">作业效率分析</div>
        <div ref="effChart" class="dc-chart"></div>
      </div>
      <div class="dc-card">
        <div class="dc-title">数据报表</div>
        <div ref="reportChart" class="dc-chart"></div>
      </div>
      <div class="dc-card">
        <div class="dc-title">区域热力分布</div>
        <div ref="heatChart" class="dc-chart"></div>
      </div>
      <div class="dc-card">
        <div class="dc-title">行驶轨迹统计</div>
        <div ref="trackChart" class="dc-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataCenter } from '@/api/sentinel'

export default {
  name: 'DataCenterIndex',
  data() {
    return { charts: [] }
  },
  mounted() {
    this.loadData()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach(c => c && c.dispose && c.dispose())
  },
  methods: {
    loadData() {
      const sample = {
        eff: { cats: ['周一','周二','周三','周四','周五','周六','周日'], series: [120, 132, 101, 134, 90, 230, 210] },
        report: { cats: ['1月','2月','3月','4月','5月','6月'], series: [320, 432, 401, 534, 590, 630] },
        heat: { cats: ['A区','B区','C区','D区','E区'], series: [80, 120, 60, 200, 95] },
        track: { cats: ['00','04','08','12','16','20','24'], series: [10, 22, 180, 240, 160, 40, 12] }
      }
      getDataCenter().then(res => {
        if (res.code === 200 && res.data) {
          const d = res.data
          if (d.eff) sample.eff = d.eff
          if (d.report) sample.report = d.report
          if (d.heat) sample.heat = d.heat
          if (d.track) sample.track = d.track
        }
      }).catch(() => {}).finally(() => {
        this.renderCharts(sample)
      })
    },
    renderCharts(d) {
      this.charts = []
      this.charts.push(this.lineChart(this.$refs.effChart, d.eff, '#165dff'))
      this.charts.push(this.barChart(this.$refs.reportChart, d.report, '#00b42a'))
      this.charts.push(this.barChart(this.$refs.heatChart, d.heat, '#ff7d00'))
      this.charts.push(this.lineChart(this.$refs.trackChart, d.track, '#f53f3f'))
    },
    lineChart(el, data, color) {
      if (!el) return null
      const chart = this.$echarts.init(el)
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 20, top: 20, bottom: 30 },
        xAxis: { type: 'category', data: data.cats, axisLine: { lineStyle: { color: '#c9cdd4' } } },
        yAxis: { type: 'value' },
        series: [{ type: 'line', smooth: true, data: data.series, itemStyle: { color }, areaStyle: { color: color + '22' } }]
      })
      return chart
    },
    barChart(el, data, color) {
      if (!el) return null
      const chart = this.$echarts.init(el)
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 20, top: 20, bottom: 30 },
        xAxis: { type: 'category', data: data.cats, axisLine: { lineStyle: { color: '#c9cdd4' } } },
        yAxis: { type: 'value' },
        series: [{ type: 'bar', data: data.series, itemStyle: { color }, barWidth: '46%' }]
      })
      return chart
    },
    resize() {
      this.charts.forEach(c => c && c.resize && c.resize())
    }
  }
}
</script>

<style scoped>
.dc-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.dc-card { background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); padding: 16px; }
.dc-title { font-size: 15px; font-weight: 600; color: #1D2129; margin-bottom: 12px; }
.dc-chart { width: 100%; height: 280px; }
@media (max-width: 768px) {
  .dc-grid { grid-template-columns: 1fr; }
}
</style>
